<template>
  <svg
    width="16"
    :height="newArticleDetailsDisplay ? '16' : '13'"
    :viewBox="newArticleDetailsDisplay ? '0 0 16 16' : '0 0 16 13'"
    :class="newArticleDetailsDisplay ? 'mr-1' : 'mr-2'"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.33028 11.9208H2.02068C1.39028 11.9208 0.879883 11.4096 0.879883 10.78V8.46001C0.879883 7.82961 1.39108 7.31921 2.02068 7.31921H4.33028C4.96068 7.31921 5.47108 7.83041 5.47108 8.46001V10.78C5.47188 11.4096 4.96068 11.9208 4.33028 11.9208Z"
      fill="currentColor"
    />
    <path
      d="M13.9787 11.9208H11.6691C11.0387 11.9208 10.5283 11.4096 10.5283 10.78V8.46001C10.5283 7.82961 11.0395 7.31921 11.6691 7.31921H13.9787C14.6091 7.31921 15.1195 7.83041 15.1195 8.46001V10.78C15.1195 11.4096 14.6091 11.9208 13.9787 11.9208Z"
      fill="currentColor"
    />
    <path
      d="M4.2 12.8256H2.2C0.9864 12.8256 0 11.8384 0 10.6256V8.61357C0 7.40077 0.9864 6.41357 2.2 6.41357H4.2C5.4136 6.41357 6.4 7.40077 6.4 8.61357V10.6256C6.4 11.8384 5.4136 12.8256 4.2 12.8256ZM2.2 7.61357C1.6488 7.61357 1.2 8.06237 1.2 8.61357V10.6256C1.2 11.1768 1.6488 11.6256 2.2 11.6256H4.2C4.7512 11.6256 5.2 11.1768 5.2 10.6256V8.61357C5.2 8.06237 4.7512 7.61357 4.2 7.61357H2.2Z"
      fill="currentColor"
    />
    <path
      d="M0.6 9.2176C0.2688 9.2176 0 8.9488 0 8.6176V4.6088C0 2.068 2.0632 0 4.6 0H5.8C6.1312 0 6.4 0.2688 6.4 0.6C6.4 0.9312 6.1312 1.2 5.8 1.2H4.6C2.7248 1.2 1.2 2.7288 1.2 4.6088V8.6176C1.2 8.9488 0.9312 9.2176 0.6 9.2176Z"
      fill="currentColor"
    />
    <path
      d="M13.7996 12.8256H11.7996C10.586 12.8256 9.59961 11.8384 9.59961 10.6256V8.61357C9.59961 7.40077 10.586 6.41357 11.7996 6.41357H13.7996C15.0132 6.41357 15.9996 7.40077 15.9996 8.61357V10.6256C15.9996 11.8384 15.0132 12.8256 13.7996 12.8256ZM11.7996 7.61357C11.2484 7.61357 10.7996 8.06237 10.7996 8.61357V10.6256C10.7996 11.1768 11.2484 11.6256 11.7996 11.6256H13.7996C14.3508 11.6256 14.7996 11.1768 14.7996 10.6256V8.61357C14.7996 8.06237 14.3508 7.61357 13.7996 7.61357H11.7996Z"
      fill="currentColor"
    />
    <path
      d="M10.1996 9.2176C9.86841 9.2176 9.59961 8.9488 9.59961 8.6176V4.6088C9.59961 2.068 11.6628 0 14.1996 0H15.3996C15.7308 0 15.9996 0.2688 15.9996 0.6C15.9996 0.9312 15.7308 1.2 15.3996 1.2H14.1996C12.3244 1.2 10.7996 2.7288 10.7996 4.6088V8.6176C10.7996 8.9488 10.5308 9.2176 10.1996 9.2176Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
  },
};
</script>
